import React from 'react';

import SelectOfferContent from './SelectOfferContent';
import { Offre } from '../../../../providers/OffresProvider';

export type SelectOfferModalProps = {
    offers: Array<Offre>;
    currentOffer?: Offre;
    onSubmit: (offer?: Offre) => void;
};

const SelectOfferModal: React.FunctionComponent<SelectOfferModalProps> = function (props) {
    const { currentOffer, offers, onSubmit } = props;

    const handleSelectOffer = (offer?: Offre) => {
        if (offer?.id !== currentOffer?.id) {
            onSubmit(offer);
        }
    };

    return (
        <SelectOfferContent
            offers={offers}
            selectedOfferId={currentOffer?.id}
            onSelectOffer={handleSelectOffer}
        />
    );
};

export default SelectOfferModal;
